// extracted by mini-css-extract-plugin
export default {"wrapper":"ShareButtons_wrapper__WnvGm","active":"ShareButtons_active__v-59Q"};